module.exports = __webpack_public_path__ + "img/marker.5c8d3879.svg";